import { LocaleStrings } from '../keys';

const ja: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'ã‚¹ãƒˆãƒ¼ãƒªãƒ¼',
  nav_create: 'ä½œæˆ',
  nav_login: 'ãƒ­ã‚°ã‚¤ãƒ³',

  page_title_main: 'Story Craft - ãƒ¡ã‚¤ãƒ³ãƒšãƒ¼ã‚¸',
  section_browse_by_category: 'ã‚«ãƒ†ã‚´ãƒªã§æŽ¢ã™',
  section_explore_new_games: 'æ–°ã—ã„ã‚²ãƒ¼ãƒ ã‚’æŽ¢ã™',
  section_popular: 'äººæ°—',
  section_trending: 'ãƒˆãƒ¬ãƒ³ãƒ‰',
  section_trending_now: '今話題',
  section_popular_picks: '人気作品',
  section_recent_stories: 'æœ€è¿‘è¦‹ãŸä½œå“',
  section_new_stories: 'æ–°ä½œ',
  btn_load_more_games: 'ã‚‚ã£ã¨èª­ã¿è¾¼ã‚€ï¼ˆæ®‹ã‚Š {count} ä»¶ï¼‰',
  text_showing_games: '{total} ä»¶ä¸­ {visible} ä»¶ã‚’è¡¨ç¤º',
  text_no_category_games: '{category} ã®ã‚²ãƒ¼ãƒ ãŒè¦‹ã¤ã‹ã‚Šã¾ã›ã‚“ã€‚',
  text_category_games: '{category} ã‚²ãƒ¼ãƒ ',
  text_error_loading_games: 'ã‚²ãƒ¼ãƒ ã®èª­ã¿è¾¼ã¿ã‚¨ãƒ©ãƒ¼: {error}',

  tell_us_tagline: 'Story Craftï¼šãƒ•ã‚¡ãƒ³ãƒ•ã‚£ã‚¯ã‚·ãƒ§ãƒ³ãŒãƒ—ãƒ¬ã‚¤ã§ãã‚‹ã‚¹ãƒˆãƒ¼ãƒªãƒ¼ã«ã€‚',
  tell_us_subtitle: 'ä»Šæ—¥ã‹ã‚‰ã‚²ãƒ¼ãƒ ã‚’å§‹ã‚ã¾ã—ã‚‡ã†ï¼',
  btn_create_now: 'ä»Šã™ãä½œæˆ',

  section_comments: 'ã‚³ãƒ¡ãƒ³ãƒˆ ({count})',
  text_no_comments: 'ã¾ã ã‚³ãƒ¡ãƒ³ãƒˆã¯ã‚ã‚Šã¾ã›ã‚“ã€‚æœ€åˆã«æ„Ÿæƒ³ã‚’å…±æœ‰ã—ã¾ã—ã‚‡ã†ï¼',
  btn_load_more_comments: 'ã‚³ãƒ¡ãƒ³ãƒˆã‚’ã‚‚ã£ã¨èª­ã¿è¾¼ã‚€',
  text_posting_comment: 'ã‚³ãƒ¡ãƒ³ãƒˆã‚’æŠ•ç¨¿ä¸­...',
  text_failed_load_comments: 'ã‚³ãƒ¡ãƒ³ãƒˆã®èª­ã¿è¾¼ã¿ã«å¤±æ•—ã—ã¾ã—ãŸ',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'ã‚²ãƒ¼ãƒ ãŒè¦‹ã¤ã‹ã‚Šã¾ã›ã‚“ - Story Craft',
  page_title_game_info: 'ã‚²ãƒ¼ãƒ æƒ…å ± - Story Craft',
  btn_play_now: 'ãƒ—ãƒ¬ã‚¤',
  btn_rate: 'è©•ä¾¡',
  section_about: 'æ¦‚è¦',
  section_tags: 'ã‚¿ã‚°',
  text_views: '{count} å›žé–²è¦§',
  text_your_rating: 'ã‚ãªãŸã®è©•ä¾¡: {rating} - {title}',
  text_game_id: 'ã‚²ãƒ¼ãƒ ID: {id}',
  text_no_description: 'ã“ã®ã‚²ãƒ¼ãƒ ã«ã¯èª¬æ˜ŽãŒã‚ã‚Šã¾ã›ã‚“ã€‚',
  text_game_not_found: 'ã‚²ãƒ¼ãƒ ãŒè¦‹ã¤ã‹ã‚Šã¾ã›ã‚“',
  text_failed_load_game: 'ã‚²ãƒ¼ãƒ æƒ…å ±ã®èª­ã¿è¾¼ã¿ã«å¤±æ•—ã—ã¾ã—ãŸ',

  section_similar_games: 'é¡žä¼¼ã‚²ãƒ¼ãƒ ',
  text_failed_load_similar: 'é¡žä¼¼ã‚²ãƒ¼ãƒ ã®èª­ã¿è¾¼ã¿ã«å¤±æ•—ã—ã¾ã—ãŸ',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'Story Craft ã‚³ãƒ¡ãƒ³ãƒˆ - è³ªå•ã¨å›žç­”ã¯ã“ã¡ã‚‰',

  section_featured: 'Story Craft ãŠã™ã™ã‚',
  section_top_genre: 'Top {genre} ã‚¹ãƒˆãƒ¼ãƒªãƒ¼',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: 'レーティング {rating}',
  rating_warn_teen_body: 'このストーリーはT（ティーン13+）レーティングです。軽度の暴力や示唆的な内容など、年少の読者に適さない場合があります。',
  rating_warn_mature_body: 'このストーリーはM（成人18+）レーティングです。強い暴力、成人向けテーマなど、成人読者のみを対象とした内容が含まれる場合があります。',
  rating_warn_continue: '続ける',
  rating_warn_go_back: '戻る',
  rating_warn_confirm_teen: '私は13歳以上であることを確認します。',
  rating_warn_confirm_mature: '私は18歳以上であることを確認します。',

  rating_section_title: 'コンテンツレーティング',
  rating_label_e: '全年齢',
  rating_label_t: 'ティーン 13+',
  rating_label_m: '成人 18+',
  rating_desc_e: '全年齢の読者に適しています。すべての人に適したコンテンツが含まれています。',

  hero_dialog_1: 'ハリー・ポッターがまたあなたのストーリーに間違った呪文をかけてしまいました。',
  hero_dialog_2: 'シェラザードは日の出前にMinaへ最後の物語を語り続けています…',
  hero_dialog_3: 'シャーロック・ホームズが失われたプロットホールを発見し、読み込みの続行を拒否しました。',
  hero_dialog_4: 'ドラキュラが第2章に入る許可を待っています。',
  hero_dialog_5: 'フロドがなぜかあなたのセーブファイルを滅びの山に落としました。',
  hero_dialog_6: 'ハリー・ポッターとMinaがタイムライン崩壊の原因について口論しています。',
  hero_dialog_7: 'シンデレラがまた真夜中に遅れたので、ロード画面が延長されました。',
  hero_dialog_8: 'ロミオとジュリエットが少し早めにあなたのバッドエンドに辿り着きました。',
  hero_dialog_9: 'アリスが間違うさぎの穴を開けて、あなたの下書きフォルダに入ってしまいました。',
  hero_dialog_10: 'Minaはもう禁断の本を読まないと約束しました。Minaは嘘をつきました。',
  hero_dialog_11: 'マーリンがストーリーエンジンの魔法のバグを修正中です。',
  hero_dialog_12: 'オデュッセウスは10年間、次の章に辿り着こうとしています。',
  hero_dialog_13: 'フランケンシュタイン博士がコードベースに触れました。もう誰も安心できません。',
  hero_dialog_14: 'ピーター・パンがこのストーリーを大人にさせることを拒否しています。',
  hero_dialog_15: '星の王子さまがMinaに、なぜ大人はこんなに悲しい結末を書くのかと尋ねました。',
};
export default ja;
